(function () {
  'use strict';
  angular.module('common')
    .component('surveyMonkey', {
        bindings: {
          promise: '<'
        },
        controller: ['localStorageService', function surveyMonkeyComponent() {
          
        }],
        template: '<a href="https://www.surveymonkey.com/r/DConnect" type="button" class="surveyMonkeyBox hidden-print logo btn-primary" target="_blank">Customer Feedback</a>'
      }
    );
})();